import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
  SearchActionHandler,
  SelectInDialogAction,
} from '@core/search';

/**
 * Handles { type: 'select-in-dialog' } actions produced by
 * PermissionsSearchProvider. The handler emits the requested selection
 * via an Observable that the open UserPermissionsDialogComponent listens
 * to; the dialog then switches activeModule, scrolls to the row, and
 * pulses the highlight.
 *
 * The dialog must be open for the action to take effect — the
 * permissions provider is only meaningful inside that dialog's scope.
 */
@Injectable({ providedIn: 'root' })
export class PermissionsSearchActionHandler
  implements SearchActionHandler<SelectInDialogAction>
{
  readonly type = 'select-in-dialog' as const;

  private selection$ = new Subject<SelectInDialogAction['dialogContext']>();

  /** Subscribe in UserPermissionsDialogComponent to react to search hits. */
  readonly selections = this.selection$.asObservable();

  handle(action: SelectInDialogAction): void {
    this.selection$.next(action.dialogContext);
  }
}
